import { useState } from 'react';
import { Svg } from '../../common/Svg';
export default function HighlightedProjectCard({highlightedProjects}) {
    const [currentIndex, setCurrentIndex] = useState(0);
    function formatTitle(originalTitle, teacherName) {
        if (!originalTitle) return '';

        let trimmedTitle = originalTitle.replace(/^Help me give my students\s*/i, '');

        trimmedTitle = trimmedTitle
            .replace(/\bmy\b/gi, 'their')
            .replace(/\bme\b/gi, 'them')
            .replace(/\bi\b/gi, teacherName);

        return `${teacherName} received ${trimmedTitle}`;
    }
    function projectCards() {
        return (
            <div className="highlighted-projects-wrapper">

                <div className="dot-pagination">
                    {highlightedProjects.map((_, index) => (
                        <button
                            key={index}
                            className={`dot ${index === currentIndex ? 'active' : ''}`}
                            onClick={() => setCurrentIndex(index)}
                            aria-label={`Go to project ${index + 1}`}
                        />
                    ))}
                </div>

                <div className="highlighted-projects-inside-container" style={{ transform: `translateX(-${currentIndex * 100}%)`, transition: 'transform 0.4s ease', display: 'flex' }}>

                    {highlightedProjects.map((proposal, index) => (
                        <div
                            className={`highlighted-projects-card ${index === currentIndex ? 'active' : 'inactive'} ${proposal.campaignFavorite ? 'is-favorite' : ''}`}
                            key={index}
                            style={{
                                opacity: index === currentIndex ? 1 : 0.5,
                                transition: 'opacity 0.3s ease',
                                position: 'relative',
                            }}
                        >


                            <p className="project-title">
                                {formatTitle(proposal.fulfillmentTrailer, proposal.teacherName)}
                            </p>


                            <div className="teacher-details-container">

                                <div className="teacher">
                                    <div className="teacher-img-container">
                                        <img src={proposal.thumbImageURL} alt="Project photo"/>
                                    </div>
                                    <div className="teacher-info">
                                        <p className="teacher-name">{proposal.teacherName}</p>
                                        <p>{proposal.schoolName} </p>
                                        <p>{proposal.city}, {proposal.state}</p>
                                    </div>
                                </div>

                                <a className="button-secondary"
                                   href={baseFrontURL + 'project/' + proposal.proposalId} target="_blank">
                                    View project
                                </a>

                            </div>

                        </div>
                    ))}


                </div>
            </div>
        );
    }

    return (
        <section id="highlighted-projects" className="campaign-page-highlighted-projects-container">

            <h2>Highlighting standout projects from this campaign</h2>

            {projectCards()}


        </section>
    );
}
